import { useNavigate } from 'react-router-dom';
import DetailsSidebar from '@/components/DetailsSidebar';
import { useSite } from '@/hooks/sites/useSite';
import SiteDetailsContent from './SiteDetailsContent';
import SiteDocumentsContent from './SiteDocumentsContent';

const SiteDrawer = ({
  siteId,
  isOpen,
  onClose,
}: {
  siteId: string | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const { data: site } = useSite(siteId ?? '');

  if (!siteId) return null;

  // OV-1375: never a slice of the internal UUID. That truncated id was the
  // "random, unknown ID" this ticket is named after — it was removed from the
  // Sites list and the detail header, but survived here, so the same site could
  // show its INV number on the list and a meaningless A1B2C3D4 in the drawer.
  //
  // Falls back to an em dash rather than the site name, unlike Show.tsx and
  // SiteBreadcrumbs: DetailsSidebar renders this prop as a 3-character bold
  // prefix plus the remainder, which is built for values shaped like "INV2606…"
  // and turns a name into "**Bos**ton General Hospital".
  const displayId = site?.display_id || '—';

  const tabs = [
    {
      id: 'details',
      label: 'Details',
      content: <SiteDetailsContent siteId={siteId} />,
    },
    {
      id: 'documents',
      label: 'Submitted Documents',
      content: <SiteDocumentsContent siteId={siteId} compact />,
    },
  ];

  return (
    <DetailsSidebar
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      displayId={displayId}
      tabs={tabs}
      defaultTab="details"
      footerLabel="View Site"
      onFooterClick={() => {
        onClose();
        navigate(`/sites/${siteId}`);
      }}
    />
  );
};

export default SiteDrawer;
